import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetPersonnelIdentityByIdRequest,
    GetPersonnelIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<GetPersonnelIdentityByIdResponse, GetPersonnelIdentityByIdResponse>,
) => response?.data?.personnelIdentity;
const getError = (
    response?: SWRResponse<GetPersonnelIdentityByIdResponse, GetPersonnelIdentityByIdResponse>,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<GetPersonnelIdentityByIdResponse, GetPersonnelIdentityByIdResponse>,
) => ({});

const usePersonnelIdentityById = (
    id?: number | null | undefined,
    configuration?:
        | SWRConfiguration<GetPersonnelIdentityByIdResponse, GetPersonnelIdentityByIdResponse>
        | null
        | undefined,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;

        return (): IReturn<GetPersonnelIdentityByIdResponse> =>
            new GetPersonnelIdentityByIdRequest({ id });
    }, [id]);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default usePersonnelIdentityById;
